import { render, staticRenderFns } from "./PersonalizedVariablePage.vue?vue&type=template&id=b1b0d7ec&"
import script from "./PersonalizedVariablePage.vue?vue&type=script&lang=js&"
export * from "./PersonalizedVariablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports